import emptyState from '../../../../../../../assets/empty-state.svg';
import { Button } from '@nexelem/components';
import { useCustomTranslation } from '../../../../../../hooks';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRotateRight } from '@fortawesome/pro-light-svg-icons';

type ToDoListEmptyStateProps = {
  onRefresh: () => void;
};

export const TasksDrawerEmptyState = ({ onRefresh }: ToDoListEmptyStateProps) => {
  const { tWrapper } = useCustomTranslation('products.productionPlan.emptyState');

  return (
    <div className="flex grow flex-col items-center justify-center gap-y-4">
      <div className="h-80 w-105 bg-center bg-no-repeat" style={{ backgroundImage: `url(${emptyState})` }} />
      <span className="text-s18 text-text-primary">{tWrapper('title')}</span>
      <Button StartIcon={<FontAwesomeIcon icon={faRotateRight} />} variant="outlined" onClick={onRefresh}>
        {tWrapper('refresh')}
      </Button>
    </div>
  );
};
